<template>
  <div class="container">
    <div class="title">
      需满足以下条件，才能注销当前账号
    </div>

    <div class="content">
      <div v-for="(item, index) in permissionList" :key="index" class="card" @click="toAppPage(item.status, item.type)">
        <div class="line">
          <div class="text">{{ item.des }}</div>
          <div v-if="!item.list || item.list.length === 0" class="check">
            <img v-if="item.status === 1" class="tag-img" src="../../assets/privacy/ic_success_g.png"/>
            <img v-else class="tag-img" src="../../assets/privacy/ic_right.png"/>
          </div>
        </div>
        <div v-if="item.list && item.list.length > 0" class="detail">
          <div v-for="(mod, i) in item.list" :key="i" class="line" @click="toAppPage(item.status, mod.service)">
            <div class="tag">
              <div class="line-b"></div>
              <span class="text">{{ mod.des }}</span>
            </div>
            <div class="check">
              <img v-if="mod.status === 1" class="tag-img" src="../../assets/privacy/ic_success_g.png"/>
              <img v-else class="tag-img" src="../../assets/privacy/ic_right.png"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div v-if="allChecked" @click="toNext" class="btn">下一步</div>
      <div v-else class="btn-g">下一步</div>
    </div>
  </div>
</template>

<script>
import api from "@/api/privacy";
import {goToAppViewByRouter} from "../../util/jsbridge";
import {Toast} from "vant";

export default {
  name: "CancelConditions",
  data() {
    return {
      phone: '',
      allChecked: false,
      permissionList: []
    };
  },
  mounted() {
    api.checkLogoutStatus({}).then(response => {
      if (response.result === 0) {
        this.permissionList = response.data
      } else {
        Toast(response.message)
      }
      this.checkSuccess()
    })
    this.phone = this.$route.query.phone
    window.scroll(0,0)
  },
  methods: {
    checkSuccess() {
      for (var i = 0; i < this.permissionList.length; i++) {
        if (this.permissionList[i].status === 0) {
          this.allChecked = false
          return
        }

        if (this.permissionList[i].list != null) {
          for (var j = 0; j < this.permissionList[i].list.length; j++) {
            var item = this.permissionList[i].list[j]
            if (item.status === 0) {
              this.allChecked = false
              return
            }
          }
        }
      }

      this.allChecked = true
    },
    toAppPage(status, type) {
      if (status === 0) {
        switch (type) {
          case 'balance':
            // 线上卡券包地址
            goToAppViewByRouter('https://app.robooot.com/web/WebActivity?externalUrl=https%3A%2F%2Fh5.bud88.com%2Fcoupon', '', '', '', '', '')
            break
          case 'bill':
            goToAppViewByRouter('https://app.robooot.com/wallet/WalletBillActivity', '', '', '', '', '')
            break
          case 'pay':
            goToAppViewByRouter('https://app.robooot.com/wallet/PayMethodActivity', '', '', '', '', '')
            break
          case 'identity':
            goToAppViewByRouter('https://app.robooot.com/auth/IndentityResultActivity', '', '', '', '', '')
            break
          case 'flashkey':
            goToAppViewByRouter('https://app.robooot.com/hardware/LightIdListActivity', '', '', '', '', '')
            break
          case 'door':
            // 线上闪开地址 
            goToAppViewByRouter('https://app.robooot.com/web/WebActivity?externalUrl=https%3A%2F%2Fh5-lock.robooot.com%2Fmanage%2Fhome', '', '', '', '', '')
            break
          case 'youke':
            // 线上优客地址
            // goToAppViewByRouter('https://app.robooot.com/web/WebActivity?externalUrl=', '', '', '', '', '')
            break
          case 'seedling':
            // 线上光芽地址
            // goToAppViewByRouter('https://app.robooot.com/web/WebActivity?externalUrl=', '', '', '', '', '')
            break
        }
      }
    },
    toNext() {
      this.$router.push({
        path: "/authCenter",
        query: {phone: this.phone}
      });
    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.container {
  background-color: white;
  min-height: 100vh;
}

.title {
  display: flex;
  box-sizing: border-box;
  padding: 5.3vw 0 8vw 5.3vw;

  font-size: 18px;
  font-weight: 600;
  color: #333333;
  line-height: 18px;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin: 0 7vw 8vw 7vw;

  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 5.3vw 7.2vw 0 5.3vw;
    box-shadow: 0 0.5vw 5.3vw 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    margin-bottom: 2.7vw;

    .line {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5.3vw;
    }

    .line-b {
      width: 1.6vw;
      height: 1.6vw;
      border-radius: 1.6vw;
      background-color: #286EFF;
      margin-right: 2.7vw;
    }

    .tag {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .detail {
      display: flex;
      flex-direction: column;
    }

    .text {
      max-width: 58.7vw;
      font-size: 14px;
      line-height: 14px;
      color: #000000;
    }

    .text-des {
      max-width: 58.7vw;
      font-size: 14px;
      line-height: 14px;
      color: #999999;
    }

    .check {
      display: flex;
      flex-direction: column;
      max-width: 20px;
      max-height: 20px;
      flex-shrink: 0;
      background-repeat: no-repeat;
    }

    .tag-img {
      width: 20px;
      height: 20px;
    }
  }
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    background-color: #286EFF;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 8vw;
  }

  .btn-g {
    background-color: #DADADA;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54.7vw;
    height: 12vw;
    color: white;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 6.1vw;
    margin-bottom: 8vw;
  }
}
</style>
